<div class="main-div background-wave">
    <app-spinner></app-spinner>
    <app-toolbar></app-toolbar>
    <router-outlet></router-outlet>
</div>